export enum DiscountType {
  PERCENT = 'percentage',
  FIXED = 'fixed',
}
